// src/redux/slices/capitalSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Use base URL from environment variable
const BASE_URL = process.env.REACT_APP_API_URL;

// Utility to get token from localStorage
const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// GET all capital requests
export const fetchCapitalRequests = createAsyncThunk(
  'capital/fetchCapitalRequests',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/capital/requests`, getAuthHeaders());
      return response.data.requests;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// POST a new capital request
export const createCapitalRequest = createAsyncThunk(
  'capital/createCapitalRequest',
  async ({ branchId, requestedAmount }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/capital/request`,
        { branchId, requestedAmount },
        getAuthHeaders()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Slice
const capitalSlice = createSlice({
  name: 'capital',
  initialState: {
    capitalRequests: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCapitalRequests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCapitalRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.capitalRequests = action.payload;
      })
      .addCase(fetchCapitalRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCapitalRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCapitalRequest.fulfilled, (state, action) => {
        state.loading = false;
        // Optionally push or refetch list
        state.capitalRequests.push(action.payload);
      })
      .addCase(createCapitalRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default capitalSlice.reducer;
